import { api } from "./api";

export const auth = api.injectEndpoints({
  endpoints: builder => ({
    getLocations: builder.query({
      query: ({ search, type }) => ({ url: `${process.env.REACT_APP_API_URL}/users/locations/?search=${search}&type=${type}` }),
      keepUnusedDataFor: 5,
    }),
    getPlans: builder.query({
      query: ({ group }) => ({ url: `${process.env.REACT_APP_API_URL}/users/plans/?group=${group}` }),
      keepUnusedDataFor: 5,
    }),
    loginUser: builder.mutation({
      query: ({ email, password }) => ({
        url: `${process.env.REACT_APP_API_URL}/users/sign-in/`,
        method: 'POST',
        body: { email, password },
      }),
    }),
    loginUserConfirm:  builder.mutation({
      query: ({ email, confirmation_code }) => ({
        url: `${process.env.REACT_APP_API_URL}/users/sign-in/confirm/`,
        method: 'POST',
        body: { email, confirmation_code },
      }),
    }),
    registerUser: builder.mutation({
      query: ({
        first_name,
        last_name,
        email,
        password,
        username,
        gender,
        age_group,
        country,
        chosen_plan,
      }) => ({
        url: `${process.env.REACT_APP_API_URL}/users/sign-up/`,
        method: 'POST',
        body: {
          first_name,
          last_name,
          email,
          password,
          username,
          gender,
          age_group,
          country,
          chosen_plan,
        },
      })
    }),
    changePassword: builder.mutation({
      query: ({
        current_password,
        new_password
      }) => ({
        url: `${process.env.REACT_APP_API_URL}/users/me/change-password/`,
        method: 'POST',
        body: {
          current_password,
          new_password
        },
      })
    }),
    resetPasswordInitiate: builder.mutation({
      query: ({
        email
      }) => ({
        url: `${process.env.REACT_APP_API_URL}/users/reset-password/initiate/`,
        method: 'POST',
        body: {
          email
        },
      })
    }),
    validateCode: builder.mutation({
      query: ({
        token
      }) => ({
        url: `${process.env.REACT_APP_API_URL}/users/reset-password/validate/`,
        method: 'POST',
        body: {
          token
        },
      })
    }),
    resetPassword: builder.mutation({
      query: ({
        token,
        password
      }) => ({
        url: `${process.env.REACT_APP_API_URL}/users/reset-password/`,
        method: 'POST',
        body: {
          token,
          password
        },
      })
    }),
  })
});

export const {
  useGetLocationsQuery,
  useGetPlansQuery,
  useLoginUserMutation,
  useRegisterUserMutation,
  useChangePasswordMutation,
  useResetPasswordInitiateMutation,
  useValidateCodeMutation,
  useResetPasswordMutation,
  useLoginUserConfirmMutation,
} = auth;
